import { tap } from 'rxjs/operators';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';
import { authenticate } from '~web/interactor/user-login/perform-login';

export const changePassword = rxTask((verificationString: string, password: string) =>
  apiClient.userLoginController
    .changePassword$({ password, verificationString })
    .pipe(tap(authenticate)),
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/interactor/user-login/perform-change-password.ts